import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { AuthorContainer, AuthorIcon, NameAndDate, PublishDate, AuthorName } from './AuthorSection.styles';
export var AuthorSection = function AuthorSection(_ref) {
  var article = _ref.article,
      fonts = _ref.fonts,
      colors = _ref.colors,
      articlePage = _ref.articlePage,
      featured = _ref.featured;
  var formattedDate = format(new Date(article.published_at), 'MMMM d, yyyy');
  return /*#__PURE__*/React.createElement(AuthorContainer, {
    articlePage: articlePage
  }, /*#__PURE__*/React.createElement(AuthorIcon, {
    author: article.primary_author
  }), /*#__PURE__*/React.createElement(NameAndDate, null, /*#__PURE__*/React.createElement(AuthorName, {
    fonts: fonts,
    colors: colors,
    featured: featured
  }, article.primary_author.name), /*#__PURE__*/React.createElement(PublishDate, {
    colors: colors,
    fonts: fonts,
    dateTime: formattedDate,
    featured: featured
  }, formattedDate)));
};
AuthorSection.propTypes = {
  articlePage: PropTypes.bool,

  /** The article object that gets passed down from ghost */
  article: PropTypes.object,

  /** Optional object that contains various colors that can be applied to the articles view */
  colors: PropTypes.object,

  /** Optional object that contains fonts that you can apply to the articles view */
  fonts: PropTypes.object,

  /** Dictates whether it's the featured article section */
  featured: PropTypes.bool
};
export default AuthorSection;